<header class="header hidden md:inline-block bg-kz-primary w-full" data-qa="header" data-qa-variant="desktop">
  <div class="lg:w-[70rem] md:w-[63rem] mx-auto pt-3 sm:pt-0">
    <div class="flex flex-wrap items-center justify-start p-0">
      <a
        class="order-1 logo flex items-center"
        [routerLink]="selectors.isAuthenticated() ? desktopDefaultPagePath : null"
        [attr.aria-label]="selectors.isAuthenticated() ? ('Go to home page' | translate) : null"
      >
        <app-logo [solid]="true" />
      </a>
      @if (selectors.isAuthenticated()) {
        <ul class="w-full sm:w-auto sm:order-2 order-last nav m-0 p-0 col-auto me-auto justify-center mb-0 flex">
          @for (menu of headerMenu(); track index; let index = $index) {
            <li>
              <a
                mat-flat-button
                color="primary"
                data-qa="header-menu-link"
                [attr.id]="'header-menu-item-' + (index + 1)"
                [attr.data-qa-path]="menu.path"
                [routerLink]="menu.path"
                [routerLinkActive]="['active']"
                [attr.data-testid]="menu.testId ?? 'header-menu-link-' + (index + 1)"
                [attr.aria-label]="('Go To' | translate) + ' ' + (menu.label | translate)"
                >{{ menu.label | translate }}</a
              >
            </li>
          }
        </ul>
      }
      <div class="ml-auto order-3 col-auto flex items-center justify-center gap-4">
        <app-selector
          optionLabel="symbol"
          optionValue="code"
          placeholder="Currency"
          icon="map-marker"
          inputId="main-currency-selector"
          overlayStyleClass="top-z-overlay"
          mode="button"
          optionIcon="icon"
          [zIndex]="2021"
          [options]="selectors.currencies()"
          [loading]="selectors.currenciesLoadState().status === 'loading'"
          [value]="selectors.activedCurrency()"
          (valueChange)="onCurrencySelect($event)"
          (optionPicked)="onCurrencyPicked($event)"
        >
          <ng-template #templateSelected let-option> {{ option.code }} - {{ option.symbol }} </ng-template>
          <ng-template #templateOptionLabel let-option> {{ option.code }} - {{ option.symbol }} </ng-template>
        </app-selector>
        <app-selector
          placeholder="Language"
          inputId="main-language-selector"
          overlayStyleClass="top-z-overlay"
          mode="button"
          [zIndex]="2021"
          [options]="languages"
          [value]="selectors.activedLanguage()"
          (valueChange)="onSetLanguage($event)"
        />
        @if (selectors.isAuthenticated()) {
          <app-selector
            inputId="main-user-menu"
            mode="button"
            overlayStyleClass="top-z-overlay"
            [zIndex]="2021"
            [buttonLabel]="selectors.userName() ?? 'Unknown User'"
            [options]="userMenuOptions"
            [selectable]="false"
            (singleSelect)="onUserMenuSelect($safeNavigationMigration($event?.value))"
          />
          @if (isChatEnabled) {
            <app-chat-header-button />
          }
          <app-cart-header-button />
        } @else {
          <ul class="sm:order-2 order-last nav m-0 p-0 col-auto me-auto justify-center mb-0 flex">
            <li>
              <a mat-flat-button color="primary" [routerLink]="'log-in'" [attr.aria-label]="'Log In' | translate">{{
                'Log In' | translate
              }}</a>
            </li>
          </ul>
        }
      </div>
    </div>
  </div>
</header>
<!--  -->
<div class="block md:hidden header-sm bg-kz-primary w-full" data-qa="header" data-qa-variant="mobile">
  <div class="header-sm-top">
    <div class="flex items-center justify-center">
      <a routerLink="./" class="logo" [attr.aria-label]="'Go to home page' | translate">
        <app-logo [solid]="true" />
      </a>
    </div>
    <div class="flex items-center justify-center">
      <button
        type="button"
        id="main-currency-selector-modal-toggle-btn"
        data-qa="header-currency-toggle-button"
        mat-icon-button
        color="white"
        [attr.aria-label]="'Select currency' | translate"
        (click)="currencySelectorRef.show()"
      >
        <mat-icon svgIcon="currency" />
      </button>
      <app-selector
        #currencySelectorRef
        class="hidden"
        optionLabel="symbol"
        optionValue="code"
        placeholder="Currency"
        icon="map-marker"
        inputId="main-currency-selector-modal"
        mode="slideUpModal"
        optionIcon="icon"
        [options]="selectors.currencies()"
        [value]="selectors.activedCurrency()"
        (valueChange)="onCurrencySelect($event)"
        (optionPicked)="onCurrencyPicked($event)"
      >
        <ng-template #templateSelected let-option> {{ option.code }} - {{ option.symbol }} </ng-template>
        <ng-template #templateOptionLabel let-option> {{ option.code }} - {{ option.symbol }} </ng-template>
      </app-selector>
      <!-- Language -->
      <button
        type="button"
        id="main-language-selector-modal-toggle-btn"
        data-qa="header-language-toggle-button"
        mat-icon-button
        color="white"
        [attr.aria-label]="'Select language' | translate"
        (click)="langSelectorRef.show()"
      >
        <mat-icon svgIcon="language" />
      </button>
      <app-selector
        #langSelectorRef
        class="hidden"
        placeholder="Language"
        inputId="main-language-selector-modal"
        mode="slideUpModal"
        [options]="languages"
        [value]="selectors.activedLanguage()"
        (valueChange)="onSetLanguage($event)"
      />
      @if (selectors.isAuthenticated()) {
        <app-cart-header-button />
        <!-- Profile -->
        <button
          mat-icon-button
          id="main-user-menu-sm-toggle-btn"
          data-qa="header-user-menu-toggle-button"
          type="button"
          color="white"
          [attr.aria-label]="'Open user menu' | translate"
          (click)="userOptionsRef.show()"
        >
          <mat-icon svgIcon="profile-outline" />
        </button>
        <app-selector
          #userOptionsRef
          class="hidden"
          mode="slideUpModal"
          inputId="main-user-menu-sm"
          [title]="selectors.userName()?.toUpperCase() ?? 'Unknown User'"
          [options]="userMenuOptions"
          (valueChange)="onUserMenuSelect($event)"
        />
      }

      <!-- Profile -->
    </div>
  </div>
  @if (selectors.isAuthenticated()) {
    <div class="header-sm-navigation" (swipeRight)="swipeRoute('right')" (swipeLeft)="swipeRoute('left')">
      <ul>
        @for (menu of headerMenu(); track index; let index = $index) {
          <li class="list" [routerLinkActive]="['active']" (isActiveChange)="onActiveChange($event, index)">
            <a
              #menuItemRef
              matRipple
              data-qa="header-menu-link"
              [attr.data-qa-path]="menu.path"
              [routerLink]="menu.path"
              [attr.data-testid]="menu.testId ? menu.testId + '-mobile' : 'header-mobile-menu-link-' + (index + 1)"
              [attr.aria-label]="('Go To' | translate) + ' ' + (menu.label | translate)"
              >{{ menu.label | translate }}</a
            >
          </li>
        }
        <!-- indicator -->
        @if (active !== undefined) {
          <div
            class="indicator animation-list animate__animated"
            animate.enter="animate__fadeIn"
            animate.leave="animate__fadeOut"
            [style.--navigation-active-offset]="indicatorOffset()"
          >
            <mat-icon class="frame start" svgIcon="menu-indicator" />
            <div class="middle" [style.width]="indicatorWidth()"></div>
            <mat-icon class="frame end" svgIcon="menu-indicator" />
          </div>
        }
      </ul>
    </div>
  }
</div>
